/* eslint-disable react/jsx-no-constructed-context-values */
import React, { Dispatch, FC, ReactNode } from 'react';
import { useDocumentBookkeepingStatus } from '../hooks/useDocumentBookkeepingStatus';
import { DocumentDto } from '../DocumentT';

interface Props {
  loading: boolean;
  syncedAt: Date | null;
  isUptodate: boolean;
  toolMissing: boolean;
  sync: () => unknown;
  syncing: boolean;
}

export const DocumentItemContext = React.createContext({} as Props);

export const DocumentItemContextProvider: FC<{
  invoice: DocumentDto;
  setDraft: Dispatch<boolean>;
  children: ReactNode;
}> = ({ invoice, setDraft, children }) => {
  const { loading, syncedAt, isUptodate, toolMissing, sync, syncing } = useDocumentBookkeepingStatus(invoice, setDraft);

  return (
    <DocumentItemContext.Provider
      value={{
        loading,
        syncedAt,
        isUptodate,
        toolMissing,
        sync,
        syncing,
      }}
    >
      {children}
    </DocumentItemContext.Provider>
  );
};
